import React, { useEffect } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { LISTING_PAGE_COUNT } from '@redux/generic/types';
import { getBusinessID } from '@utils/auth';
import MenuLink from '../MenuLink';
import { validateCapability, handleNewEventMixPanel } from '@utils/helpers';

function ReportSidebar({
  match,
  match: { params },
  authenticationReducer,
  genericReducer: {
    listingPageCount: {
      data: { groupTotalCount },
    },
  },
  dispatch,
}) {
  const { businessTokenData } = authenticationReducer;

  useEffect(() => {
    dispatch({
      type: LISTING_PAGE_COUNT.REQUEST,
      version: '1.0',
      tenantId: getBusinessID(),
      unit: params.code,
    });
  }, [params.code, dispatch]);

  const logEvent = (event) => {
    handleNewEventMixPanel(event, 'view', authenticationReducer, match);
  };

  const links = [];

  if (validateCapability(businessTokenData, 'REPORT')) {
    links.push({
      name: 'Overview',
      conditional: 'Global',
      icon: ['fal', 'globe'],
      translator: 'OVERVIEW',
      disabled: false,
      logger: () => logEvent('click_overview_sub_menu'),
    });
  }

  if (validateCapability(businessTokenData, 'GENERAL_LISTING')) {
    links.push({
      name: 'Listing',
      conditional: 'Groups',
      icon: ['fal', 'layer-group'],
      translator: 'LIST_ALL',
      disabled: false,
      logger: () => logEvent('click_list_all_sub_menu'),
    });
  }

  if (validateCapability(businessTokenData, 'ENGAGEMENT')) {
    links.push({
      name: 'Engagement',
      conditional: 'All',
      icon: ['fal', 'thumbs-up'],
      translator: 'ENGAGEMENT',
      disabled: false,
      logger: () => logEvent('click_engagement_sub_menu'),
    });
  }

  if (validateCapability(businessTokenData, 'VIDEO_VIEW')) {
    links.push({
      name: 'VideoView',
      conditional: 'All',
      icon: ['fal', 'video'],
      translator: 'VIDEO_VIEW',
      disabled: false,
      logger: () => logEvent('click_video_view_sub_menu'),
    });
  }

  if (validateCapability(businessTokenData, 'REPORT_COMMENTS')) {
    links.push({
      name: 'Comments',
      conditional: 'All',
      icon: ['fal', 'comment'],
      translator: 'COMMENTS',
      disabled: false,
      logger: () => logEvent('click_comments_sub_menu'),
    });
  }

  if (validateCapability(businessTokenData, 'ACTIVITY')) {
    if (groupTotalCount > 0) {
      links.push({
        name: 'Activity',
        conditional: 'All',
        icon: ['fal', 'heart-rate'],
        translator: 'ACTIVITY',
        disabled: false,
        logger: () => logEvent('click_activity_sub_menu'),
      });
    }
  }

  if (validateCapability(businessTokenData, 'REPORT_RANKING')) {
    links.push({
      name: 'Ranking',
      conditional: 'Accounts',
      icon: ['fal', 'child'],
      translator: 'RANKING',
      disabled: false,
      logger: () => logEvent('click_ranking_sub_menu'),
    });
  }

  if (validateCapability(businessTokenData, 'REPORT_AUDIENCE')) {
    links.push({
      name: 'Audience',
      conditional: 'Age&Gender',
      icon: ['fal', 'glasses'],
      translator: 'AUDIENCE',
      disabled: false,
      logger: () => logEvent('click_audience_sub_menu'),
    });
  }

  if (validateCapability(businessTokenData, 'REPORT')) {
    links.push({
      name: 'Custom',
      conditional: 'All',
      icon: ['fal', 'heart'],
      translator: 'CUSTOM',
      disabled: false,
      logger: () => logEvent('click_custom_sub_menu'),
    });
  }

  return <MenuLink links={links} page="Report" />;
}

function mapStateToProps(state) {
  return {
    authenticationReducer: state.authenticationReducer,
    genericReducer: state.genericReducer,
  };
}

export default withRouter(connect(mapStateToProps)(ReportSidebar));
